import React from 'react'
import { IShopWholesaler } from '@cbgms/api'
import { IInternalOnboardingContextValue } from './OnboardingContext'

export const OnboardingContext = React.createContext<IInternalOnboardingContextValue | undefined>(undefined)

export interface IOnboardingContextValue extends Omit<IInternalOnboardingContextValue, 'wholesaler'> {
  wholesaler: IShopWholesaler
}

// useOnboardingContext will provide the onboarding context,
// we've separated this from the context file due to circular dependencies, (context -> use-steps -> step component -> use-context)
export function useOnboardingContext() {
  const context = React.useContext(OnboardingContext)
  if (context === undefined || !context.hasBeenProvided) {
    console.error('useOnboardingContext must be used within an OnboardingContext')
  }

  return context as IOnboardingContextValue
}
